var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(0 0.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 20,
    height: 20,
    transform: "translate(0 -0.189)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M1714,2319.847l-1.062-.594a.845.845,0,0,1-.438-.736v-1.853a.844.844,0,0,1,.438-.736l1.062-.594a.835.835,0,0,0,.321-1.161l-1.286-2.158a.892.892,0,0,0-1.2-.312l-1.062.594a.9.9,0,0,1-.877,0l-1.656-.927a.845.845,0,0,1-.438-.736v-1.188a.864.864,0,0,0-.877-.85h-2.572a.864.864,0,0,0-.877.85v1.188a.845.845,0,0,1-.439.736l-1.656.927a.9.9,0,0,1-.877,0l-1.062-.595a.893.893,0,0,0-1.2.312l-1.286,2.158a.835.835,0,0,0,.321,1.16l1.062.594a.844.844,0,0,1,.439.736v1.853a.845.845,0,0,1-.439.736l-1.062.594a.835.835,0,0,0-.321,1.16l1.286,2.158a.892.892,0,0,0,1.2.311l1.062-.594a.9.9,0,0,1,.877,0l1.656.927a.846.846,0,0,1,.439.736v1.188a.864.864,0,0,0,.877.85h2.572a.864.864,0,0,0,.877-.85v-1.188a.845.845,0,0,1,.438-.736l1.656-.927a.9.9,0,0,1,.877,0l1.062.594a.892.892,0,0,0,1.2-.311l1.286-2.157A.835.835,0,0,0,1714,2319.847Zm-8.359.934a3.191,3.191,0,1,1,3.18-3.191A3.186,3.186,0,0,1,1705.643,2320.781Z",
    transform: "translate(-1695.582 -2308.787)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSetting);
export default __webpack_public_path__ + "static/media/white_setting.131692b65449a7c7aa8c88639f283a26.svg";
export { ForwardRef as ReactComponent };